import styled from 'styled-components';

import { Button } from '@xingternal/button';
import { PopOver } from '@xingternal/pop-over';
import { scale070, spaceXXS } from '@xingternal/tokens';

export const CompassLegendButton = styled(Button)`
  display: flex;
  font-size: ${scale070};
  padding: 0;
`;

export const Legend = styled.div`
  text-align: left;
  font-weight: 400;
  margin-right: ${spaceXXS};
`;

export const StyledPopOver = styled(PopOver)`
  text-align: left;
`;
